import PropTypes from 'prop-types'
import AppStore from '@v4/store/appStore'
import { memo, useEffect } from 'react'
import scoreappApi from '@v4/api/scoreappApi'

const AxiosStore = ({ children }) => {
	const store = AppStore.useStore()

	useEffect(() => {
		scoreappApi.store = store
	}, [store])
	return children || null
}

AxiosStore.propTypes = {
	children: PropTypes.node,
}

export default memo(AxiosStore)
